import React from 'react';
import { Link } from 'react-router';
import { I18n as I } from 'react-redux-i18n';
import { formatCurrencyRounded } from 'vdlib';

import Counter from './Counter';

class AdminDashboard extends React.Component {
  render() {
    const containerClassName4 = 'col-md-3 col-sm-6 col-12';
    //const containerClassName = 'col-md-4 col-sm-6 col-12';

    return (
      <div>
        <hr className="clear" />
        <div className="row">
          <Link to="/auctions" className={containerClassName4}>
            <Counter
              colorClassName="green"
              icon="line-chart"
              title={I.t('CURRENT')}
              value={this.props.TotalActiveAuctionCount || 0}
              amount={formatCurrencyRounded(
                this.props.TotalActiveAuctionAmount || 0
              )}
            />
          </Link>
          <Link to="/auctions/pending-approval" className={containerClassName4}>
            <Counter
              colorClassName="blue"
              icon="legal"
              title={I.t('PENDING_APPROVAL')}
              value={this.props.TotalForApproveAuctionCount || 0}
              amount={formatCurrencyRounded(
                this.props.TotalForApproveAuctionAmount || 0
              )}
            />
          </Link>
          <Link to="/auctions/for-selection" className={containerClassName4}>
            <Counter
              colorClassName="yellow"
              icon="trophy"
              title={I.t('FOR_SELECTION')}
              value={this.props.TotalForSelectAuctionCount || 0}
              amount={formatCurrencyRounded(
                this.props.TotalForSelectAuctionAmount || 0
              )}
            />
          </Link>
          <Link to="/auctions/for-acceptance" className={containerClassName4}>
            <Counter
              colorClassName="blue"
              icon="comments"
              title={I.t('FOR_ACCEPTANCE')}
              value={this.props.TotalForAcceptAuctionCount || 0}
              amount={formatCurrencyRounded(
                this.props.TotalForAcceptAuctionAmount || 0
              )}
            />
          </Link>
        </div>
        <div className="row">
          <Link to="/auctions/no-offer" className={containerClassName4}>
            <Counter
              colorClassName="red"
              icon="ambulance"
              title={I.t('NO_OFFER')}
              value={this.props.TotalAuctionsWithoutBid || 0}
              amount={formatCurrencyRounded(
                this.props.TotalAuctionsWithoutBidAmount || 0
              )}
            />
          </Link>
          <Link to="/auctions/completed" className={containerClassName4}>
            <Counter
              colorClassName="yellow"
              icon="thumbs-up"
              title={I.t('COMPLETED_PL_FEM')}
              value={this.props.TotalFinishedAuctionCount || 0}
              amount={formatCurrencyRounded(
                this.props.TotalFinishedAuctionAmount || 0
              )}
            />
          </Link>
        </div>

        <hr className="clear" />
      </div>
    );
  }
}

export default AdminDashboard;
